"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.credentialsHeader = exports.frontendPathHeader = exports.traceIdHeader = void 0;
exports.traceIdHeader = "mama-trace-id";
exports.frontendPathHeader = "mama-frontend-path";
exports.credentialsHeader = "same-origin";
